import {defaultItems} from '../recoil-store/recoil-state';

/**
 * @description This function lets you return flow history.
 * @returns     History
 * @author      ibrahim AKIN
 */
export const history = {
    past: [],
    present: defaultItems,
    future: []
}

export const handleUndo = () => {
    let present = history.past.pop();
    if (present) {
        history.future.push(JSON.parse(JSON.stringify(history.present)));
        history.present = JSON.parse(JSON.stringify(present));
        return present;
    }
}

export const handleRedo = () => {
    let present = history.future.pop();
    if (present) {
        history.past.push(JSON.parse(JSON.stringify(history.present)));
        history.present = JSON.parse(JSON.stringify(present));
        return present;
    }
}

export const handleUpdate = (present) => {
    if (history.past.length > 30) {
        history.past.shift();
    }
    history.past.push(JSON.parse(JSON.stringify(history.present)));
    history.present = JSON.parse(JSON.stringify(present));
    history.future = [];
}

export const handleInit = (initial) => {
    history.present = initial;
}
